import React, { useContext, useEffect, useState } from "react";
import { getLabelPrinting } from "./service";
import { AppContext } from "../context";
import LoadingSpinner from "./LoadingSpinner";
import {
  PanelContainer,
  LabelPrintingContainer,
  ItemContainer,
  LastItem,
  Label1Logo,
  Label1,
  Label2,
  Label2_1,
  Label2_2,
  PanelDetails,
  RoomDetails,
} from "./style";
import { Modal, ModalBody } from "reactstrap";
import { useParams } from "react-router-dom";

const LabelPrinting = () => {
  const { projectInfo: project } = useContext(AppContext);
  const [labelPrintingData, setLabelPrintingData] = useState(null);
  const [printingDataPerPage, setPrintingDataPerPage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({ type: "", message: "" });

  const params = useParams();
  const projectId = params.projectId;
  const orderId = params.orderId;

  const [margins, setMargins] = useState({
    top: 0,
    left: 0,
    row: 0,
    col: 0,
    rows: 0,
    cols: 0,
    orderId: 0,
  });

  const [clientLogo, setClientLogo] = useState(null);
  const [isStale, setIsStale] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setMargins({
      top: parseInt(urlParams.get("top_margin")) || 0,
      left: parseInt(urlParams.get("left_margin")) || 0,
      row: parseInt(urlParams.get("row_margin")) || 0,
      col: parseInt(urlParams.get("col_margin")) || 0,
      rows: parseInt(urlParams.get("rows")) || 0,
      cols: parseInt(urlParams.get("cols")) || 0,
      orderId: parseInt(urlParams.get("order_id")) || undefined,
    });

    setClientLogo(urlParams.get("client_logo"));
  }, []);

  useEffect(() => {
    handleUpdatePricingSummary();
  }, [project]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        history.back();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleUpdatePricingSummary = () => {
    setIsLoading(true);
    getLabelPrinting({ projectId: projectId, orderId })
      .then(({ panels, is_bom_stale }) => {
        splitPrintingDataPerPage(panels);
        setIsStale(is_bom_stale);

        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setNotification({ type: "danger", message: "Error fetching data" });
      });
  };

  const splitPrintingDataPerPage = (data) => {
    const subArrays = [];
    const label_count_per_page = 24;

    for (let i = 0; i < data.length; i += label_count_per_page) {
      subArrays.push(data.slice(i, i + label_count_per_page));
    }

    setPrintingDataPerPage(subArrays);
  };

  const renderPanels = (printingData) => {
    if (printingData !== null) {
      return printingData.map((panelData, index) => (
        <ItemContainer
          key={index}
          style={{
            height: `${
              (296 - margins.top * 2) / margins.rows -
              margins.row * (margins.rows - 1)
            }mm`,
            width: `${
              (210 - margins.left * 2 - margins.col * (margins.cols - 1)) /
              margins.cols
            }mm`,
            margin: `${margins.row / 2.0}mm ${margins.col / 2.0}mm`,
          }}
        >
          <Label1Logo>
            {clientLogo && clientLogo !== "none" && (
              <img
                src={`/logo/${clientLogo}.png`}
                className="sticker-logo custom"
              />
            )}
            {!clientLogo && (
              <img src="/logo/boxs.png" className="sticker-logo boxs" />
            )}
          </Label1Logo>
          <Label1>{panelData.factory_label}</Label1>
          <Label2>
            <Label2_1>{panelData.cabinet_label}</Label2_1>
            <Label2_2>
              {panelData.component_label}
              {panelData.display_label && <>/ {panelData.display_label}</>}
            </Label2_2>
          </Label2>
          <RoomDetails>
            <span className="room_name">{panelData.room_name}</span>
          </RoomDetails>
          <PanelDetails>
            <span className="panel_name">{panelData.name}&nbsp;</span>
            <span className="dimensions">
              ({panelData.length_1} x {panelData.length_2})
            </span>
          </PanelDetails>
        </ItemContainer>
      ));
    } else {
      return null;
    }
  };

  return (
    <Modal isOpen={true} fullscreen>
      <ModalBody className="pt-0 ps-5">
        {notification.type && (
          <div className={`alert alert-${notification.type}`} role="alert">
            {notification.message}
          </div>
        )}
        {isStale && (
          <div className="bg-dark-subtle text-danger p-2 text-center w-100 fw-bold fs-6 top-0 z-1 d-flex mt-3">
            <div className="flex-grow-1">Labels are outdated</div>
          </div>
        )}
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <div id="printable-div">
            {printingDataPerPage &&
              printingDataPerPage.map((data, index) => (
                <LabelPrintingContainer
                  style={{
                    padding: `${margins.top - margins.row / 2.0}mm ${
                      margins.left - margins.col / 2.0
                    }mm`,
                  }}
                >
                  {renderPanels(data)}
                </LabelPrintingContainer>
              ))}
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default LabelPrinting;
